var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "icon-container", class: `name-${_vm.name}` },
    [
      _vm.name === "ChevronIcon"
        ? [
            _c(
              "svg",
              {
                staticClass: "icon",
                staticStyle: { "enable-background": "new 0 0 100 100" },
                attrs: {
                  version: "1.1",
                  id: "Layer_1",
                  "xmlns:cc": "http://creativecommons.org/ns#",
                  "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                  "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  x: "0px",
                  y: "0px",
                  viewBox: "0 0 100 100",
                  "xml:space": "preserve",
                },
              },
              [
                _c("g", [
                  _c(
                    "g",
                    {
                      attrs: {
                        transform:
                          "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
                      },
                    },
                    [
                      _c("path", {
                        staticClass: "st0",
                        attrs: {
                          "shape-rendering": "auto",
                          "color-rendering": "auto",
                          "image-rendering": "auto",
                          d: "M12.463,28.116\n            c-1.726,0-3.125,1.4-3.125,3.126c0,0.843,0.341,1.651,0.946,2.239l37.5,37.5c1.22,1.22,3.199,1.22,4.419,0l37.5-37.5\n            c1.243-1.197,1.281-3.176,0.084-4.419c-1.197-1.243-3.176-1.281-4.419-0.084c-0.028,0.027-0.056,0.055-0.084,0.084L49.994,64.352\n            L14.703,29.062C14.115,28.457,13.307,28.116,12.463,28.116L12.463,28.116z",
                        },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }